export default "__VITE_ASSET__DvAASCGv__"